import React from 'react';
import {
    Select,
    SelectContent,
    SelectItem,
    SelectTrigger,
    SelectValue,
} from "./select";

const TailwindSelect = ({
    label,
    placeholder,
    items = [],
    value,
    onChange,
    invalid = false,
    errorText,
    disabled = false,
    className = "",
    labelColor = "gray.700",
    labelClassName = null,
    triggerClassName = "bg-white dark:bg-gray-800 border-gray-200 dark:border-gray-700",
    ...props
}) => {
    const computedLabelClass = labelClassName
        ? labelClassName
        : `text-sm font-medium ${labelColor && typeof labelColor === 'string' ? (labelColor.startsWith('text-') ? labelColor : `text-${labelColor.replace(/\./g, '-')}`) : 'text-gray-700 dark:text-gray-300'}`

    return (
        <div className={`space-y-2 ${className}`}>
            {label && (
                <label className={computedLabelClass}>
                    {label}
                </label>
            )}
            <Select
                value={value}
                onValueChange={onChange}
                disabled={disabled}
                {...props}
            >
                <SelectTrigger className={`${invalid ? "border-red-500" : ""} ${triggerClassName} h-9 w-full px-3 py-2`}>
                    <SelectValue placeholder={placeholder} />
                </SelectTrigger>
                <SelectContent className="bg-white dark:bg-gray-800">
                    {items.map((item) => (
                        <SelectItem key={item.value} value={item.value}>
                            {item.label}
                        </SelectItem>
                    ))}
                </SelectContent>
            </Select>
            {errorText && (
                <p className="text-xs text-red-500">{errorText}</p>
            )}
        </div>
    );
};

export default TailwindSelect;